import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/Footer.css';
import logo from '../assets/logo.png';

const Footer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, anchor: string) => {
    e.preventDefault();
    const anchorId = anchor.replace('#', '');
    
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first
      navigate('/');
      // Scroll to anchor after navigation completes
      setTimeout(() => {
        const scrollToAnchor = () => {
          const element = document.getElementById(anchorId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          } else {
            // Retry if element not found yet
            setTimeout(scrollToAnchor, 50);
          }
        };
        scrollToAnchor();
      }, 200);
    } else {
      // If on home page, just scroll to anchor
      const element = document.getElementById(anchorId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="KMD Classic Logo" />
            <h3>Komodo Classic</h3>
            <p>Reviving the Essence of Komodo</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>Navigation</h4>
              <ul>
                <li><a href="#features" onClick={(e) => handleNavClick(e, '#features')}>Features</a></li>
                <li><a href="#history" onClick={(e) => handleNavClick(e, '#history')}>History</a></li>
                <li><a href="#faq" onClick={(e) => handleNavClick(e, '#faq')}>FAQ</a></li>
                <li><a href="#donations" onClick={(e) => handleNavClick(e, '#donations')}>Donations</a></li>
                </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Resources</h4>
              <ul>
                <li><a href="https://explorer.kmdclassic.com/" target="_blank">Explorer</a></li>
                <li><a href="https://roadmap.kmdclassic.com/" target="_blank" rel="noopener noreferrer">Roadmap</a></li>
                <li><a href="https://github.com/kmdclassic/KmdClassic/releases/latest" target="_blank" rel="noopener noreferrer">Download Wallet</a></li>
                <li><a href="https://dex.kmdclassic.com/" target="_blank" rel="noopener noreferrer">DEX</a></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Community</h4>
              <ul>
                <li><a href="https://discord.gg/ZBZnx4CxXb" target="_blank">Discord</a></li>
                <li><a href="https://x.com/komodo_classic" target="_blank">X</a></li>
                <li><a href="https://t.me/komodoclassic" target="_blank">Telegram</a></li>
                <li><a href="https://github.com/kmdclassic/KmdClassic">GitHub</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Komodo Classic (KMDCL). All rights reserved.</p>
          <p>
            The KMDCL project does not set itself against KMD but rather seeks to revive and enhance features 
            that were important to the community.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
